import { Component, Input, Output, EventEmitter, OnChanges } from '@angular/core';
import { Events } from 'ionic-angular';
//declare var DocumentPickerSwift: any;

@Component({
    selector: 'custom-datepicker',
    templateUrl: 'custom-datepicker.html'
})
export class CustomDatePickerComponent implements OnChanges {
    @Output() selectDate = new EventEmitter<any>();
    @Input() inputdate: any;
    @Input() popup: any;
    @Input() maxDate: any;
    months = [
        'January', 'February', 'March', 'April', 'May', 'June', 'July',
        'August', 'September', 'October', 'November', 'December'
    ];
    years: any = [];
    year: any;
    month: any;
    day: any;
    days = [];
    currentyear = new Date().getFullYear()
    currentmonth = new Date().getMonth() + 1
    constructor() {
        for (let i = 1920; i <= 2050; i++) {
            this.years.push(i);
        }
        if (!this.inputdate) {
            this.setToday();
        } else {
            this.day = this.inputdate.day;
            this.month = this.inputdate.month;
            this.year = this.inputdate.year;
            this.currentmonth = this.month;
            this.currentyear = this.year
            this.daysInMonth(1, this.month, this.year);
        }
    }

    setToday() {
        const date = new Date();
        this.day = date.getDate();
        this.month = date.getMonth() + 1;
        this.year = date.getFullYear();
        this.currentmonth = this.month
        this.currentyear = this.year
        this.daysInMonth(1, this.month, this.year);
    }

    togglePopup() {
        if (this.popup) {
            this.popup = false;
        } else {
            this.popup = true;
        }
    }

    daysInMonth(start, month, year) {
        this.days = [];
        const days = ['sunday', 'monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday'];
        let nofday = new Date(year, month, 0).getDate();
        let dayobj = {};
        for (let i = start; i <= nofday; i++) {
            const d = new Date(year + '-' + this.checkLeadingZero(month) + '-' + this.checkLeadingZero(i));
            const dayName = days[d.getDay()];
            dayobj[dayName] = { day: i, disable: false };
            if (dayName == 'saturday' || i == nofday) {
                this.days.push(dayobj);
                dayobj = {};
            }
        }
        console.log(this.maxDate)
        if (this.maxDate) {
            this.checkMaxDate()
        }

    }

    checkMaxDate() {
        const maxdateobj = new Date(this.maxDate);
        const maxYear = maxdateobj.getFullYear();
        const maxMonth = maxdateobj.getMonth() + 1
        const maxDay = maxdateobj.getDate()
        for (const item of this.days) {

            if (this.year > maxYear || (this.year == maxYear && this.month > maxMonth)) {
                if (item.sunday) {
                    item.sunday['disable'] = true;
                }
                if (item.monday) {
                    item.monday['disable'] = true;
                }
                if (item.tuesday) {
                    item.tuesday['disable'] = true;
                }
                if (item.wednesday) {
                    item.wednesday['disable'] = true;
                }
                if (item.thursday) {
                    item.thursday['disable'] = true;
                }
                if (item.friday) {
                    item.friday['disable'] = true;
                }
                if (item.saturday) {
                    item.saturday['disable'] = true;
                }
            } else {
                if (this.year == maxYear && this.month == maxMonth && item.sunday && item.sunday.day > maxDay) {
                    item.sunday['disable'] = true;
                } else if (item.sunday) {
                    item.sunday['disable'] = false;
                }

                if (this.year == maxYear && this.month == maxMonth && item.monday && item.monday.day > maxDay) {
                    item.monday['disable'] = true;
                } else if (item.monday) {
                    item.monday['disable'] = false;
                }

                if (this.year == maxYear && this.month == maxMonth && item.tuesday && item.tuesday.day > maxDay) {
                    item.tuesday['disable'] = true;
                } else if (item.tuesday) {
                    item.tuesday['disable'] = false;
                }

                if (this.year == maxYear && this.month == maxMonth && item.wednesday && item.wednesday.day > maxDay) {
                    item.wednesday['disable'] = true;
                } else if (item.wednesday) {
                    item.wednesday['disable'] = false;
                }
                if (this.year == maxYear && this.month == maxMonth && item.thursday && item.thursday.day > maxDay) {
                    item.thursday['disable'] = true;
                } else if (item.thursday) {
                    item.thursday['disable'] = false;
                }
                if (this.year == maxYear && this.month == maxMonth && item.friday && item.friday.day > maxDay) {
                    item.friday['disable'] = true;
                } else if (item.friday) {
                    item.friday['disable'] = false;
                }
                if (this.year == maxYear && this.month == maxMonth && item.saturday && item.saturday.day > maxDay) {
                    item.saturday['disable'] = true;
                } else if (item.saturday) {
                    item.saturday['disable'] = false;
                }
            }
        }
        console.log(this.days)
    }

    onChangeMonthYear() {
        this.daysInMonth(1, this.month, this.year);
    }

    setDays(item) {
        console.log('aaaa', item)
        if (!item || item.disable) {
            return false;
        } else {
            this.currentyear = this.year
            this.currentmonth = this.month
            this.day = item.day;
            this.selectDate.emit({ day: this.day < 10 ? '0' + this.day : this.day, month: this.month < 10 ? '0' + this.month : this.month, year: this.year })

        }
    }

    checkLeadingZero(val) {
        if (val < 10) {
            return '0' + val;
        }
        return val;
    }

    nextDay() {
        let nofday = (year, month) => new Date(year, month, 0).getDate();
        let currentyear = this.day + 1 > nofday(this.year, this.month) && this.month + 1 > 12 ? this.year + 1 : this.year;
        let currentmonth = this.day + 1 > nofday(this.year, this.month) ? (this.month + 1) : this.month;
        currentmonth = currentmonth > 12 ? 1 : currentmonth;
        this.day = this.day + 1 > nofday(this.year, this.month) ? 1 : this.day + 1;
        if (this.currentmonth != currentmonth) {
            this.month = currentmonth;
            this.currentmonth = currentmonth;
            this.onChangeMonthYear()
        } else {
            this.month = currentmonth;
            this.currentmonth = currentmonth;
        }

        if (this.currentyear != currentyear) {
            this.year = currentyear;
            this.currentyear = currentyear;
            this.onChangeMonthYear()
        } else {
            this.year = currentyear;
            this.currentyear = currentyear;
        }
    }

    prevDay() {
        let nofday = (year, month) => new Date(year, month, 0).getDate();
        let currentyear = this.day - 1 == 0 && this.month - 1 == 0 ? this.year - 1 : this.year;
        let currentmonth = this.day - 1 == 0 ? (this.month - 1) : this.month;
        currentmonth = currentmonth == 0 ? 12 : currentmonth;
        this.day = this.day - 1 == 0 ? nofday(currentyear, currentmonth) : this.day - 1;
        if (this.currentmonth != currentmonth) {
            this.month = currentmonth;
            this.currentmonth = currentmonth;
            this.onChangeMonthYear()
        } else {
            this.month = currentmonth;
            this.currentmonth = currentmonth;
        }

        if (this.currentyear != currentyear) {
            this.year = currentyear;
            this.currentyear = currentyear;
            this.onChangeMonthYear()
        } else {
            this.year = currentyear;
            this.currentyear = currentyear;
        }
    }

    ngOnChanges() {
        console.log(this.maxDate)
        this.daysInMonth(1, this.month, this.year);
    }
}



// WEBPACK FOOTER //
// ./src/component/custom-datepicker/custom-datepicker.ts